import styled from "styled-components";
import theme from "../../../Themes/light";
import { ThemeType } from "../../../types/Theme";

export const ContainerGoogle = styled.div<{ theme: ThemeType }>`
  padding: 3rem 0 5rem;

  .ga4-gtm-radios{
    width: 100%;
    display: flex;
    gap: 3rem;

    @media (max-width: 768px) {
      flex-direction: column;
      gap: 0.5rem;
    }

    .modo-radio{
      display: flex;
      gap: 0.5rem;
      padding: 5px 0;
      cursor: pointer;
      white-space: nowrap;
      color: ${(props) => props.theme.colors.tertiary};

      input[type="radio"]{
        accent-color: ${(props) => props.theme.colors.primary};
        margin: 0;
        cursor: pointer;
      }
    }
  }

  .modo-descricao{
    font-size: 11px;
    color: ${(props) => props.theme.colors.tertiary};
  }
`;
